"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _profile = require("@widget/profile");

var _utils = require("@package/utils");

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _Status = _interopRequireDefault(require("./Status"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["shopsInProcess", "onModeration", "rowIndex"];

function TableComponent(_ref) {
  var shopsInProcess = _ref.shopsInProcess,
      onModeration = _ref.onModeration,
      rowIndex = _ref.rowIndex,
      shop = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var handleModeration = function handleModeration(shopId) {
      onModeration(shopId);
    };

    var _useSelector = (0, _reactRedux.useSelector)(_profile.selectProfile),
        permissions = _useSelector.user.permissions;

    var hasPermissionUpdate = (0, _utils.checkPermission)(permissions, 'shop.get');
    var isPermissionToModerate = (0, _utils.checkPermission)(permissions, 'shop.status.tomoderation');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['tr'],
      key: shop['id']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['status']),
      "data-locator": "table.shops.row[".concat(rowIndex, "].col[0].status")
    }, /*#__PURE__*/_react["default"].createElement(_Status["default"], {
      status: shop['status'],
      form: 'point'
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['name']),
      "data-locator": "table.shops.row[".concat(rowIndex, "].col[1].shop")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['shop'],
      "data-locator": 'table.shops.shop'
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _defaultModule["default"]['shop__name'],
      "data-locator": 'table.shops.shop.name'
    }, shop['name'], shop['demoMode'] && /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['shop__test']
    }, "test")), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['shop__id'],
      "data-locator": 'table.shops.shop.shopId'
    }, shop['id']))), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['url']),
      "data-locator": "table.shops.row[".concat(rowIndex, "].col[2].website")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['shop']
    }, shop['webSite'] ? /*#__PURE__*/_react["default"].createElement("a", {
      className: _defaultModule["default"]['shop__site'],
      href: shop['webSite'],
      target: "_blank",
      rel: "noopener noreferrer",
      "data-locator": 'table.shops.shop.website'
    }, shop['webSite']) : /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['shop__empty'],
      "data-locator": 'table.shops.shop.website.empty'
    }, "\u043D\u0435\u0442"))), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['status-2']),
      "data-locator": "table.shops.row[".concat(rowIndex, "].col[3].status-2")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['shop']
    }, /*#__PURE__*/_react["default"].createElement(_Status["default"], {
      status: shop['status']
    }))), isPermissionToModerate && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['status-3']),
      "data-locator": "table.shops.row[".concat(rowIndex, "].col[4].status-3")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['shop']
    }, shop['status'] && shop['status'] === 'New' && /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": 'table.shops.shop.to-moderation',
      mode: "primary",
      form: "outline",
      size: "small",
      disabled: shopsInProcess.indexOf(shop['id']) > -1,
      onClick: function onClick() {
        return handleModeration(shop['id']);
      }
    }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043D\u0430 \u043C\u043E\u0434\u0435\u0440\u0430\u0446\u0438\u044E"))), hasPermissionUpdate && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['control']),
      "data-locator": "table.shops.row[".concat(rowIndex, "].col[5].control")
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      className: (0, _classnames["default"])(_defaultModule["default"]['shop__edit'], 'icon-more'),
      to: process.env['PUBLIC_URL'] + '/shops/' + shop['id'],
      "data-locator": 'table.shops.shop.details'
    })));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = TableComponent;
exports["default"] = _default;